/*
 * @Author: FengXiao
 * @Date: 2020-07-01 22:19:22
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-03 21:56:36
 */
import axios from 'axios';
import { Message } from 'element-ui';
const SUCCESS_COODES = ['0', 0, '200', 200];
const httpConfig = {
  timeout: 30000,
  // baseURL: process.env.VUE_APP_URL,
};
const service = axios.create(httpConfig);

service.interceptors.request.use(
  config => {
	  config.headers['authcode'] = '$yf&cpup8d%@s2h%'
    // 去get缓存hack
    if (config.method === 'get') {
      config.params = { ...config.params, ...{ _: new Date().getTime() } };
    }
    // 去get缓存hack
    if (config.method === 'get') {
      config.params = { ...config.params, ...{ _: new Date().getTime() } };
    }
    return config;
  },
  error => Promise.reject(error)
);
service.interceptors.response.use(
  res => {
    // 隐私改版：全站匿名访问，登录态相关分支已移除
    if (SUCCESS_COODES.includes(res.data.error_code)) {
      return res.data.data;
    }
    if (res.config.printMsg) {
      Message.error(res.data.error_msg);
    }
    return Promise.reject(res.data);
  },
  error => Promise.reject(error)
);

export default service;
